// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"AccesoriosTable_spinnerContainer__q+xrp","botonAdd":"AccesoriosTable_botonAdd__3FQ0u"};